import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_decision_history } from "../services/api";
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import prevArrow from "../assets/prevArrow.png";
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import clock from "../assets/clock.png";
import target from "../assets/target.png";
import profitreport from "../assets/profitreport.png";
import trophy from "../assets/trophy.png";
import QmModuleStyle from "../styles/qm.module.css";

const DecisionHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [listOfUsers, setListOfUsers] = useState([]);
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [decisionhistory, setDecisionhistory] = useState([]);
  const [attempt, setAttempt] = useState(queryParams.get("attempt"));
  const [pagination, setPagination] = useState({ prev: false, next: false });
  const [executioninstanceid, setExecutioninstanceid] = useState("");
  const [decisionPageHeight, setDecisionPageHeight] = useState("");
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError,] = useOutletContext();
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = Number(decisionhistory?.summary?.starRating);
  const TargetSR = simObj?.laststate?.TargetSR;

  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");

  const checkNum = (num, factor) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: factor,
        maximumFractionDigits: factor,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: factor,
        maximumFractionDigits: factor,
      })}`;
  };
  const initDecisionHistory = () => {
    (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/qm/simulation`);
    window.$("html, body").animate({ scrollTop: 0 }, 100);
    setIsLoader(true);
  };
  const backToSimulationList = () => {
    setIsLoader(true);
    if (role == "student") {
      navigate(rootRoute + `/qm/studentreview?${queryParams}`);
    } else {
      navigate(rootRoute + `/qm/instructorreview?${queryParams}`);
    }
  };
  const getNextAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index + 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index + 2] != undefined
        ? setPagination({ prev: true, next: false })
        : setPagination({ prev: false, next: true });
    } else {
      setPagination({ prev: false, next: true });
      setIsLoader(false);
    }
  };
  const getPrevAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index - 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index - 2] != undefined
        ? setPagination({ prev: false, next: false })
        : setPagination({ prev: true, next: false });
    } else {
      setPagination({ prev: true, next: false });
      setIsLoader(false);
    }
  };
  const OnLoadPagination = () => {
    let lastObjIndex = simulationDetailSummary?.length - 1;
    let firstObjIndex = 0;
    let currentIndex = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    currentIndex == lastObjIndex && setPagination({ prev: false, next: true });
    currentIndex == firstObjIndex && setPagination({ prev: true, next: false });
    if (currentIndex != lastObjIndex && currentIndex != firstObjIndex) {
      setPagination({ prev: false, next: false });
    }
  };
  const getSimulationDetailSummary = () => {
    setSimulationDetailSummary(
      attempt != undefined && user_id != undefined
        ? simObj?.simulationdetails
        : []
    );
    setIsLoader(false);
  };
  const updateExcutionInstanceId = () => {
    if (attempt != undefined && user_id != undefined) {
      setExecutioninstanceid(
        simulationDetailSummary?.filter(
          (sdObj) => sdObj.attemptno == attempt
        )[0]?.executioninstanceid
      );
    } else {
      setExecutioninstanceid(simObj?.executioninstanceid);
    }
  };
  const getDecisionHistory = () => {
    (simObj?.sessionid != undefined || session_id != undefined) &&
      executioninstanceid != undefined &&
      executioninstanceid.length > 0 &&
      get_decision_history(simObj?.sessionid || session_id, executioninstanceid)
        .then((response) => {
          if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
            setError(response?.data)
        }
        else{
          setDecisionhistory(response?.data);
          OnLoadPagination();
          setIsLoader(false);
          setIsOverlay(false);
        }
        })
        .catch((error) => {
          // setError(errorMsg);
          setError({"id":"00000","msg":errorMsg})
          console.log(error);
        });
  };

  useEffect(() => {
    updateExcutionInstanceId();
  }, [simulationDetailSummary]);
  useEffect(() => {
    getSimulationDetailSummary();
    if (document.querySelector(`.${QmModuleStyle["decision-table"]}`) != null) {
      document.querySelector(
        `.${QmModuleStyle["decision-table"]}`
      ).scrollTop = 0;
    }
  }, [attempt]);
  useEffect(() => {
    getDecisionHistory();
  }, [executioninstanceid]);
  useEffect(() => {
    if(document.querySelector("header.header") != null){
      document.querySelector("header.header").style.display = "none";
    }
    document.querySelector(
      `.${QmModuleStyle["decisionhistory-container"]} header.header h1`
    ).tabIndex = -1;
    const decisionHistoryPageHeight =
      window.innerHeight -
      document.getElementsByClassName(`${QmModuleStyle.header}`)[0]
        .clientHeight -
      document.getElementsByClassName(`${QmModuleStyle.header2}`)[0]
        .clientHeight -
      document.getElementsByClassName(
        `ui grid ${QmModuleStyle.ui} ${QmModuleStyle.grid}`
      )[0].clientHeight -
      document.querySelector(`.footer`).clientHeight -
      20;
    setDecisionPageHeight(decisionHistoryPageHeight);
    document.querySelector(".App .row").style.minHeight = "auto";
    document.querySelector(".App").style.overflow = "hidden";
    initDecisionHistory();
    setAttempt(queryParams.get("attempt"));
    // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
    //   document.querySelector(
    //     "footer.footer .footer-nav .footer-links"
    //   ).style.display = "none";
    // }
    // if (document.querySelector("footer.footer .container") != null) {
    //   document.querySelector("footer.footer .container").style.justifyContent =
    //     "center";
    // }
    if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
    }
    document.title = "Quality Management | Decision History";
    setIsOverlay(false);
    return () => {
      document.querySelector(".App .row").style.minHeight = "100vh";
      document.body.style.overflow = "auto";
      if (
        document.querySelector(
          `.${QmModuleStyle["decisionhistory-container"]} header.header`
        ) != undefined
      ) {
        document.querySelector(
          `.${QmModuleStyle["decisionhistory-container"]} header.header`
        ).style.display = "block";
      }
      if (
        document.querySelector("footer.footer .footer-nav .footer-links") !=
        null
      ) {
        document.querySelector(
          "footer.footer .footer-nav .footer-links"
        ).style.display = "block";
      }
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector(
          "footer.footer .container"
        ).style.justifyContent = "space-between";
      }
    };
  }, []);

  return (
    <motion.div
      className={`${QmModuleStyle["decisionhistory-container"]}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <header className={`header ${QmModuleStyle.header}`}>
        <div className={`container ${QmModuleStyle.container}`}>
          <div className={`${QmModuleStyle["icon-header-box"]}`}>
            {attempt != undefined && user_id != undefined && (
              <button onClick={backToSimulationList}>
                <img src={prevArrow} />
              </button>
            )}
          </div>
          <h1>Decision History</h1>
        </div>
      </header>
      <div className={`${QmModuleStyle["decisionhistory-wrapper"]}`}>
        <div className={`${QmModuleStyle.header2}`}>
          <h3>
            {attempt != undefined &&
              `Quality Management Simulation (Attempt ${attempt})`}
          </h3>

          <div>
            {attempt != undefined &&
              user_id != undefined &&
              simulationDetailSummary?.length != 1 && (
                <div className={`${QmModuleStyle["pagination-icons"]}`}>
                  <button disabled={pagination.prev} onClick={getPrevAttempt}>
                    <img src={leftArrow} />
                  </button>
                  <button disabled={pagination.next} onClick={getNextAttempt}>
                    <img src={rightArrow} />
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className={`ui grid ${QmModuleStyle.ui} ${QmModuleStyle.grid}`}>
          <div className={`column ${QmModuleStyle.column}`}>
            <img src={clock} />
            <span>
              {decisionhistory?.summary?.startday}-
              {decisionhistory?.summary?.endday}
            </span>
            <p>Simulation Started - Ended</p>
          </div>
          <div className={`column ${QmModuleStyle.column}`}>
            <img src={target} />
            <span>{checkNum(decisionhistory?.summary?.targetprofit)}</span>
            <p>Target Net Profit</p>
          </div>
          <div className={`column ${QmModuleStyle.column}`}>
            <img src={profitreport} />
            <span>{checkNum(Number(decisionhistory?.summary?.grossprofit))}</span>
            <p>Actual Profit</p>
          </div>
          <div className={`column ${QmModuleStyle.column}`}>
            <img src={trophy} />
            <span>{decisionhistory?.summary?.status}</span>
            <p>Goal Achieved</p>
          </div>

          <div className={`column ${QmModuleStyle.column}`}>
            <img src={trophy} />
            <span>
              <span className="sr-only">
                {decisionhistory?.summary?.starRating} star rating
              </span>
              <ul className={`${QmModuleStyle["rating-list"]}`}>
                {noOfRatings.map((number, index) =>
                  number <= starRating ? (
                    <li key={index + "_01"}>
                      <span
                        className={`fa fa-star checked ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star"]} ${QmModuleStyle["checked"]}`}
                      />
                    </li>
                  ) : Number(starRating) === starRating &&
                    starRating % 1 !== 0 &&
                    number <= Math.round(starRating) ? (
                    <li key={index + "_01"}>
                      <span
                        className={`fa fa-star-half-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-half-o"]}`}
                      />
                    </li>
                  ) : (
                    <li key={index + "_01"}>
                      <span
                        className={`fa fa-star-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-o"]}`}
                      />
                    </li>
                  )
                )}
              </ul>
            </span>
            <p>Star Rating</p>
          </div>
          <div className={`column ${QmModuleStyle.column}`}>
            <img src={trophy} />
            <span>{decisionhistory?.summary?.score}%</span>
            <p>Score</p>
          </div>
        </div>

        <div
          className={`${QmModuleStyle["decision-table"]}`}
          style={{ height: decisionPageHeight + "px" }}
        >
          <table
            className={`ui unstackable table ${QmModuleStyle.ui} ${QmModuleStyle.unstackable} ${QmModuleStyle.table}`}
          >
            <thead>
              <tr>
                <th className={`column`}>Simulation Duration</th>
                <th className={`column`}>Investments Made</th>
                <th className={`column`}>
                  Investments Cost for the Duration ($)
                </th>
                <th className={`column`}>Net Profit for the Duration ($)</th>
                <th className={`column`}>Star Rating</th>
                <th className={`column`}>Average Failure Rate</th>
              </tr>
            </thead>
            <tbody>
              {decisionhistory?.detail?.map((detailObj, index) => (
                <tr key={index + "_03"}>
                  <td>{detailObj?.simulationPeriod}</td>
                  <td className={`${QmModuleStyle["investment-list"]}`}>
                    {
                      detailObj?.decisionHistory?.map((dh, index) => (
                        <>
                          <ol key={index}>
                            {
                              dh?.options?.map((item, index) => {
                                return <li key={index + "_03"}>{item}</li>
                              })
                            }
                          </ol>
                          <p>{dh.orderday}</p>
                        </>
                      ))
                    }
                  </td>
                  <td>{checkNum(Number(detailObj?.cost), 2)}</td>
                  <td>{checkNum(Number(detailObj?.profit), 2)}</td>
                  <td>
                    <span className="sr-only">
                      {Number(detailObj?.starrating)} star rating
                    </span>
                    <ul className={`${QmModuleStyle["rating-list"]}`}>
                      {noOfRatings.map((number, index) =>
                        number <= Number(detailObj?.starrating) ? (
                          <li key={index + "_02"}>
                            <span
                              className={`fa fa-star checked ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star"]}`}
                            />
                          </li>
                        ) : Number(detailObj?.starrating) ===
                          Number(detailObj?.starrating) &&
                          Number(detailObj?.starrating) % 1 !== 0 &&
                          number <=
                          Math.round(Number(detailObj?.starrating)) ? (
                          <li key={index + "_02"}>
                            <span
                              className={`fa fa-star-half-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-half-o"]}`}
                            />
                          </li>
                        ) : (
                          <li key={index + "_02"}>
                            <span
                              className={`fa fa-star-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-o"]}`}
                            />
                          </li>
                        )
                      )}
                    </ul>
                  </td>
                  <td>{Number(detailObj?.averageFailureRate).toFixed(2)}%</td>
                </tr>
              ))}
              <tr className={`${QmModuleStyle["total-row"]}`}>
                <td colSpan={2} className={`left aligned`}>
                  Totals
                </td>
                <td colSpan={4}>{checkNum(Number(decisionhistory?.summary?.totalCost))}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>
  );
};

export default DecisionHistory;
